// Form

// header
import './header/header'

// aboutUs
import './aboutUs/aboutUs'

// Form Old
import './formsOld/formsOld'

// Swiper Slider
import './sliderSwiper/sliderSwiper'

// Scroll
import './scroll/scroll'

// lazy-load
import './lazy-load/lazy-load'

// mainFunction
import './mainFunction/mainFunction'
